import {LOG_TEXT_LIST} from '@/common/Constant'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'

export const filterSidebarList = {
  data() {
    return {
      userList: [],
      actionList: LOG_TEXT_LIST,
      filter: {
        userIdSelected: null,
        actionSelected: [],
        dateFrom: moment().format('YYYY-MM-DD'),
        dateTo: moment().format('YYYY-MM-DD'),
        is_all: true
      },
      filterMap: {},
      countOpenFilterPanel: 0
    }
  },
  computed: {
    ...mapState('auth', ['users']),
    userSelected() {
      return this.filter.userIdSelected
    },
    actionSelected() {
      return this.filter.actionSelected
    }
  },
  created() {
    this.initData()
  },
  methods: {
    ...mapActions('auth', ['getUserList']),
    initData() {
      this.filterMap['date_from'] = moment(this.filter.dateFrom).format('YYYY-MM-DD')
      this.filterMap['date_to'] = moment(this.filter.dateTo).format('YYYY-MM-DD')
      this.filterMap['is_all'] = this.filter.is_all
    },
    mapFilter(_filterItem, _key, _type) {
      if (_type !== 'not_array') {
        this.filterMap[_key] = []
        _filterItem.forEach(item => {
          this.filterMap[_key].push(item['id'])
        })
        if (!this.filterMap[_key].length) {
          delete this.filterMap[_key]
        }
      } else {
        if (_key !== 'is_all') {
          this.filterMap[_key] = _filterItem && _filterItem.id
        } else {
          this.filterMap[_key] = _filterItem
        }
        if (_key !== 'is_all' && !this.filterMap[_key]) {
          delete this.filterMap[_key]
        }
      }
    },
    customLabelUserList({name, full_name}) {
      return `${name} [${full_name}]`
    },
    async getUserListWhenOpenSidebar() {
      if (this.countOpenFilterPanel === 0) {
        await this.getUserList()
      } else {
        if (!this.userList.length) {
          await this.getUserList()
        }
      }
      this.userList = this.users
      this.countOpenFilterPanel++
    },
    resetCondition() {
      this.filter['userIdSelected'] = null
      this.filter['actionSelected'] = []
      this.filter['dateFrom'] = moment().format('YYYY-MM-DD')
      this.filter['dateTo'] = moment().format('YYYY-MM-DD')
      this.filter['is_all'] = true

      this.onInputDateFrom()
      this.onInputDateTo()
    },
    onInputDateFrom() {
      this.filterMap['date_from'] = moment(this.filter.dateFrom).format('YYYY-MM-DD')
    },
    onInputDateTo() {
      this.filterMap['date_to'] = moment(this.filter.dateTo).format('YYYY-MM-DD')
    }
  },
  watch: {
    userSelected(value) {
      this.mapFilter(value, 'user_id', 'not_array')

      let isAll = true
      isAll = !(value && Object.keys(value).length > 0)
      this.mapFilter(isAll, 'is_all', 'not_array')
    },
    actionSelected(value) {
      this.mapFilter(value, 'action')
    }
  }
}
